<template>
  <div class="container-fluid" style="overflow-y: hidden">
    <div class="text-center" v-show="isUserInfoLoading">
      <div>
        <b-spinner
          label="Spinning"
          variant="success"
          style="width: 10rem; height: 10rem"
        ></b-spinner>
      </div>
    </div>

    <div class="row" style="height:100%; margin-top: 10px">
      <div class="col-12" style="height:100%;">
        <b-table
          class="textMiddle"
          style="height: 100%;"
          small
          hover
          bordered
          show-empty
          responsive
          head-variant="light"
          :items="users"
          :fields="headers"
          v-bind:emptyText="$store.state.localization.data.common.table.noData"
          v-bind:sticky-header="clientHeight"
        >
          <template v-slot:empty="scope">
            <div class="row justify-content-md-center">
              <h5>{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button
              style="font-size: 12px"
              @click="showUserInfo(row.item, row.index, $event.target)"
              variant="success"
            >
              {{ $store.state.localization.data.common.table.edit }}
            </b-button>
          </template>
        </b-table>
        <b-modal ref="user-info-modal" size="lg" @ok="updateUserInfo">
          <b-tabs style="font-size: 12px">
            <b-tab
              :title="
                $store.state.localization.data.mainPage.users.userInfo.tabs.main
              "
              active
            >
              <b-form-checkbox v-model="userInfo.state">
                {{
                  $store.state.localization.data.mainPage.users.userInfo.state
                }}
              </b-form-checkbox></b-tab
            >
            <b-tab
              :title="
                $store.state.localization.data.mainPage.users.userInfo.tabs
                  .roles
              "
            >
              <div
                class="row no-gutters"
                style="margin-left: 5px; margin-bottom: 5px"
              >
                <div class="col-5">
                  <b-form-select
                    v-model="userInfo.roles.left.data"
                    :options="userInfo.roles.left.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="rolesLeftRef"
                  ></b-form-select>
                </div>
                <div class="col-1 align-self-center" style="text-align: center">
                  <b-button-group vertical>
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectRoles"
                      >&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectAllRoles"
                      >&#62;&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectAllRoles"
                      >&#60;&#60;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectRoles"
                      >&#60;</b-button
                    >
                  </b-button-group>
                </div>
                <div class="col-5">
                  <b-form-select
                    v-model="userInfo.roles.right.data"
                    :options="userInfo.roles.right.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="rolesRightRef"
                  ></b-form-select>
                </div>
              </div>
            </b-tab>
            <b-tab
              :title="
                $store.state.localization.data.mainPage.users.userInfo.tabs
                  .fuelDepos
              "
            >
              <div
                class="row no-gutters"
                style="margin-left: 5px; margin-bottom: 5px"
              >
                <div class="col-5">
                  <b-form-select
                    v-model="userInfo.fuelDepos.left.data"
                    :options="userInfo.fuelDepos.left.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="fuelDeposLeftRef"
                  ></b-form-select>
                </div>
                <div class="col-1 align-self-center" style="text-align: center">
                  <b-button-group vertical>
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectFuelDepos"
                      >&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectAllFuelDepos"
                      >&#62;&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectAllFuelDepos"
                      >&#60;&#60;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectFuelDepos"
                      >&#60;</b-button
                    >
                  </b-button-group>
                </div>
                <div class="col-5">
                  <b-form-select
                    v-model="userInfo.fuelDepos.right.data"
                    :options="userInfo.fuelDepos.right.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="fuelDeposRightRef"
                  ></b-form-select>
                </div>
              </div>
            </b-tab>
          </b-tabs>
          <template v-slot:modal-header="{}">
            <div>{{ userInfoModal.title }}</div>
          </template>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button
              variant="light"
              style="font-size: 12px"
              @click="cancel()"
              >{{
                $store.state.localization.data.common.table.cancel
              }}</b-button
            >
            <b-button variant="success" style="font-size: 12px" @click="ok()">{{
              $store.state.localization.data.common.table.ok
            }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { roleService, userService } from "../../../services";

export default {
  name: "Users",
  props: {
    fuelDepos: Array,
  },
  data() {
    return {
      isUserInfoLoading: false,
      roles: [],
      users: [],
      userInfoModal: {
        id: null,
        title: null,
      },
      userInfo: {
        state: false,
        roles: {
          left: {
            data: [],
            values: [],
          },
          right: {
            data: [],
            values: [],
          },
        },
        fuelDepos: {
          left: {
            data: [],
            values: [],
          },
          right: {
            data: [],
            values: [],
          },
        },
      },
    };
  },
  computed: {
    headers() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.users
        .tableColumns) {
        headers.push({
          key: key,
          label: this.$store.state.localization.data.mainPage.users
            .tableColumns[key],
          sortable: true,
          thClass: "textMiddle",
        });
      }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 100;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
  },
  async created() {
    if (
      this.$store.state.authentication.roles.indexOf(
        roleService.SUPER_ADMIN_ROLE
      ) != -1 ||
      this.$store.state.authentication.roles.indexOf(
        roleService.ADMIN_ROLE
      ) != -1
    ) {
      const rolesResponse = await roleService.getRoles();

      if (rolesResponse.isSuccess) {
        this.roles = rolesResponse.data.roles;
      }

      const usersResponse = await userService.getUsers();

      if (usersResponse.isSuccess) {
        this.users = usersResponse.data.users;
      }
    }
  },
  methods: {
    async showUserInfo(item) {
      this.userInfoModal.id = item.id;
      this.userInfoModal.title = item.userName;

      const userInfoResponse = await userService.getUserInfo(item.id);

      if (userInfoResponse.isSuccess) {
        this.userInfo.state = userInfoResponse.data.userInfo.isEnabled;

        this.userInfo.roles.left.data = [];
        this.userInfo.roles.left.values = [];
        this.userInfo.roles.right.data = [];
        this.userInfo.roles.right.values = [];

        this.userInfo.fuelDepos.left.data = [];
        this.userInfo.fuelDepos.left.values = [];
        this.userInfo.fuelDepos.right.data = [];
        this.userInfo.fuelDepos.right.values = [];

        for (let i = 0; i < this.roles.length; i++) {
          const role = userInfoResponse.data.userInfo.roles.find(
            (x) => x.name == this.roles[i].name
          );
          if (role) {
            this.userInfo.roles.right.values.push({
              value: this.roles[i].id,
              text: this.roles[i].name,
            });
          } else {
            this.userInfo.roles.left.values.push({
              value: this.roles[i].id,
              text: this.roles[i].name,
            });
          }
        }

        this.fuelDepos.sort(function (a, b) {
          if (a.companyId == b.companyId) {
            return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
          } else {
            return a.companyName.toUpperCase() > b.companyName.toUpperCase()
              ? 1
              : -1;
          }
        });

        for (let i = 0; i < this.fuelDepos.length; i++) {
          const fuelDepo = userInfoResponse.data.userInfo.fuelDepos.find(
            (x) => x.id == this.fuelDepos[i].id
          );
          if (fuelDepo) {
            this.userInfo.fuelDepos.right.values.push({
              value: this.fuelDepos[i].id,
              text: `${this.fuelDepos[i].companyName}|${this.fuelDepos[i].name}`,
            });
          } else {
            this.userInfo.fuelDepos.left.values.push({
              value: this.fuelDepos[i].id,
              text: `${this.fuelDepos[i].companyName}|${this.fuelDepos[i].name}`,
            });
          }
        }
      }
      this.$refs["user-info-modal"].show();
    },
    async updateUserInfo() {
      const userInfo = {
        userId: this.userInfoModal.id,
        isEnabled: this.userInfo.state,
        roles: [],
        fuelDepos: [],
      };

      for (let i = 0; i < this.userInfo.roles.right.values.length; i++) {
        userInfo.roles.push(this.userInfo.roles.right.values[i].value);
      }

      for (let i = 0; i < this.userInfo.fuelDepos.right.values.length; i++) {
        userInfo.fuelDepos.push(this.userInfo.fuelDepos.right.values[i].value);
      }

      this.isUserInfoLoading = true;
      const updateUerInfoResponse = await userService.updateUserInfo(userInfo);

      if (!updateUerInfoResponse.isSuccess) {
        //TODO: add error handling
      }
      this.isUserInfoLoading = false;
    },
    selectRoles() {
      for (let i = 0; i < this.userInfo.roles.left.data.length; i++) {
        const columnIndex = this.userInfo.roles.left.values.findIndex(
          (x) => x.value == this.userInfo.roles.left.data[i]
        );

        this.userInfo.roles.right.values.push(
          this.userInfo.roles.left.values[columnIndex]
        );
        this.userInfo.roles.left.values.splice(columnIndex, 1);
      }
    },
    selectAllRoles() {
      for (let i = 0; i < this.userInfo.roles.left.values.length; i++) {
        this.userInfo.roles.right.values.push(
          this.userInfo.roles.left.values[i]
        );
      }

      this.userInfo.roles.left.data = [];
      this.userInfo.roles.left.values = [];
    },
    deselectRoles() {
      for (let i = 0; i < this.userInfo.roles.right.data.length; i++) {
        const columnIndex = this.userInfo.roles.right.values.findIndex(
          (x) => x.value == this.userInfo.roles.right.data[i]
        );

        this.userInfo.roles.left.values.push(
          this.userInfo.roles.right.values[columnIndex]
        );
        this.userInfo.roles.right.values.splice(columnIndex, 1);
      }
    },
    deselectAllRoles() {
      for (let i = 0; i < this.userInfo.roles.right.values.length; i++) {
        this.userInfo.roles.left.values.push(
          this.userInfo.roles.right.values[i]
        );
      }

      this.userInfo.roles.right.data = [];
      this.userInfo.roles.right.values = [];
    },
    selectFuelDepos() {
      for (let i = 0; i < this.userInfo.fuelDepos.left.data.length; i++) {
        const columnIndex = this.userInfo.fuelDepos.left.values.findIndex(
          (x) => x.value == this.userInfo.fuelDepos.left.data[i]
        );

        this.userInfo.fuelDepos.right.values.push(
          this.userInfo.fuelDepos.left.values[columnIndex]
        );
        this.userInfo.fuelDepos.left.values.splice(columnIndex, 1);
      }
    },
    selectAllFuelDepos() {
      for (let i = 0; i < this.userInfo.fuelDepos.left.values.length; i++) {
        this.userInfo.fuelDepos.right.values.push(
          this.userInfo.fuelDepos.left.values[i]
        );
      }

      this.userInfo.fuelDepos.left.data = [];
      this.userInfo.fuelDepos.left.values = [];
    },
    deselectFuelDepos() {
      for (let i = 0; i < this.userInfo.fuelDepos.right.data.length; i++) {
        const columnIndex = this.userInfo.fuelDepos.right.values.findIndex(
          (x) => x.value == this.userInfo.fuelDepos.right.data[i]
        );

        this.userInfo.fuelDepos.left.values.push(
          this.userInfo.fuelDepos.right.values[columnIndex]
        );
        this.userInfo.fuelDepos.right.values.splice(columnIndex, 1);
      }
    },
    deselectAllFuelDepos() {
      for (let i = 0; i < this.userInfo.fuelDepos.right.values.length; i++) {
        this.userInfo.fuelDepos.left.values.push(
          this.userInfo.fuelDepos.right.values[i]
        );
      }

      this.userInfo.fuelDepos.right.data = [];
      this.userInfo.fuelDepos.right.values = [];
    },
  },
};
</script>

<style>
.textMiddle {
  vertical-align: middle !important;
  text-align: center !important;
  min-width: 20px !important;
}
</style>


